import PlainButton, { UnileverButton } from '../components/ButtonComponents';
import PageHeader from '../components/PageHeader';
import { ReactComponent as Folder } from '../assets/icon/folder.svg';
import { ReactComponent as DoubleSideArrow } from '../assets/icon/doubleSideArrow.svg';
import { ReactComponent as Save } from '../assets/icon/Save.svg';
import { ReactComponent as Edit_1 } from '../assets/icon/Edit_1.svg';
import { ReactComponent as CopyIcon } from '../assets/icon/CopyIcon_Black.svg';
import { ReactComponent as SendButton } from '../assets/icon/SendButton.svg';
import { ReactComponent as BlackTrash } from '../assets/icon/blackTrash.svg';
import ModelView from '../components/PromptPlayGroundPopUp';
import { useEffect, useRef, useState } from 'react';
import DropDownComponent, {
  BlueDropDownComponent,
  headerFunction,
  RangeSelector,
  SearchableDropDownComponent,
  TextArea,
  TextFieldComponent,
  ToolTipFunction
} from '../components/inputField';
import './PromptPlayground.css';
import { Button, ListGroup } from 'react-bootstrap';
import Accordion from '../components/Accordion/Accordion';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchMyPromptDetails } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import { usePromptPlaygroundContext } from '../context/PromptPlayGroundContext';
import SavePromptPopUp from '../components/SavePromptPopUp';
import { usePromptContext } from '../context/PromptContextType';
import CreditBalanceBox from '../components/CreditBalanceBox';
import { ReactComponent as DeletePopUpIcon } from '../assets/icon/DeletePopUpIcon.svg';
import UnileverAnimation from '../components/UnileverAnimation';
import ReactMarkdown from 'react-markdown';

type historyTypeData = {
  playground_id: string;
  name: string;
  description: string;
  prompt_id: null;
  message_count: number;
  preview: string;
  created_at: string;
  updated_at: string;
  created_by: string;
  variables: [
    {
      VariableName: string;
      DefaultValue: string;
      Description: string;
    }
  ];
  params: {};
  runs: number;
};

export default function PromptPlayground() {
  const iconStyle = { width: 15, height: 15, marginRight: 5 };
  const { apiToken } = useAzureData();
  const borderDetails = {
    border: '1px solid var(--border-color-grey)',
    // padding: '16px',
    borderRadius: 4
  };
  const [selectedPrompt, setSelectedPrompt] = useState('');
  const {
    playgroundData = { data: { items: [] }, loading: false, error: '' },
    playgroundDetails,
    // indexDetails,

    chatData,
    ChatFunction,
    MessageHistoryFunction,
    messageHistory,
    PlaygroundChatDeleteFunction,
    //
    modelDataFunction,
    modelData,
    EditChatMessageFunction,
    editChatMessage
  } = usePromptPlaygroundContext();
  const navigate = useNavigate();
  const {
    myPrompt,
    setMyPrompt,
    creditDataFunction,
    selectedApplication,
    setDeduction,
    indexSelection,
    IndexOptions,
    handleSetIndexData
  } = usePromptContext();
  const { credit_id: CREDIT_ID = 0 } = selectedApplication || {};
  const [isViewMaximum, setIsViewMaximum] = useState(false);
  const [popUpType, setPopUpType] = useState('');
  const [flag, setFlag] = useState(false);
  const [ModelOptions, setModeloptions] = useState([{ title: '', id: '' }]);
  // myPromptLocal is added locally to manage isssue which was conign because
  // of   setMyPrompt(''); in return statment
  const [myPromptLocal, setMyPromptLocal] = useState('');

  const defaultModel = ModelOptions?.[0]?.title;
  // myInputData
  const promptParams = {
    model: defaultModel,
    temperature: 0.5,
    maximumLength: 1024,
    topP: 1,
    frequencyPenalty: 0,
    presencePenalty: 0,
    systemPrompt: '',
    stopSequence: [],
    variable: [],
    index: 0,
    search_top_k: 5
  };
  const [inputData, setInputData] = useState(promptParams);

  // Common Paramter for Tuning Data
  const tuningData = {
    model: inputData?.model,
    temperature: inputData?.temperature,
    max_length: inputData?.maximumLength,
    top_p: inputData?.topP,
    stopSequence: inputData?.stopSequence,
    frequencyPenalty: inputData?.frequencyPenalty,
    presencePenalty: inputData?.presencePenalty
  };

  useEffect(() => {
    // fetching Chat History
    playgroundDetails();
    // fetching all available models
    modelDataFunction();

    // setting true when page loads for the first time
    setFlag(true);
    creditDataFunction();
    setIsNewChat(true);
    return () => {
      setMyPrompt('');
      setAllMessages([]);
      setInputData(promptParams);
    };
  }, []);

  // setting Model and Index Value
  useEffect(() => {
    const values_2 = modelData?.data?.endpoints;
    if (Array.isArray(values_2)) {
      const temp = values_2?.map((item) => {
        // return { title: item?.endpoint_name, id: item?.endpoint_group_id };
        return { title: item?.endpoint_name, id: item?.endpoint_name };
      });
      setModeloptions(temp || []);

      setInputData({ ...inputData, model: temp?.[0]?.title });
    }
  }, [modelData]);

  const [dataToShow, setDataToShow] = useState({});
  const [availableVersions, setAvailableVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(1);
  const [allMessages, setAllMessages] = useState([
    {
      role: '',
      message: '',
      run_id: ''
    }
  ]);
  const [chatHistory, setChatHistory] = useState([{ playground_id: '' }]);

  useEffect(() => {
    const temp = parseInt(availableVersions?.[0]?.version);
    if (temp) {
      setSelectedVersion(temp);
    }
  }, [availableVersions]);

  useEffect(() => {
    // /fetching data for selected prompt
    if (myPrompt) {
      try {
        fetchMyPromptDetails(myPrompt, apiToken)?.then((data) => {
          setDataToShow(data);
          handleInitialValuesForPrompt(data);
          setMyPromptLocal(myPrompt);
          if (
            !!chatHistory?.[0]?.playground_id &&
            !playgroundData?.loading &&
            !playgroundData?.error &&
            !!playgroundData?.data
          ) {
            handleNewChat(playgroundData?.data?.items);
          }
          const temp = data?.promptsData?.map((item: any) => {
            return {
              version: item?.prompt?.promptVersion,
              creation_date: item?.prompt?.creation_date
            };
          });

          setAvailableVersions(temp);
        });
      } catch (err) {
        console.log(err);
        alert(err);
      } finally {
        setPopUpType('');
      }
    }
  }, [myPrompt]);

  const handleInitialValuesForPrompt = (data: any) => {
    const temp = data?.promptsData?.filter(
      (item) => item?.prompt?.promptVersion == selectedVersion
    )?.[0];

    const tempUserPrompt = [
      {
        role: 'user',
        message: temp?.prompt?.prompt?.map((item) => item?.text)?.join(' '),
        run_id: ''
      }
    ];

    if (temp) {
      setInputData({
        ...inputData,
        model: temp?.prompt?.llmTestedWith || defaultModel,
        variable: temp?.variables,
        systemPrompt: temp?.prompt?.systemPrompt
      });

      //  when   it is single prompt , converting "UserPrompt" into "Chat type view"
      if (temp?.prompt?.is_interaction_type_single) {
        setAllMessages(tempUserPrompt);
      } else {
        setAllMessages(temp?.roles);
      }
    }
  };

  useEffect(() => {
    handleInitialValuesForPrompt(dataToShow);
  }, [selectedVersion]);

  // function for setting new message
  const newChatPlayground = {
    playground_id: '',
    name: 'New Chat',
    description: '',
    prompt_id: null,
    message_count: 0,
    preview: 'New Chat',
    created_at: '',
    updated_at: '',
    created_by: '',
    variables: [
      {
        VariableName: '',
        DefaultValue: '',
        Description: ''
      }
    ],
    params: {},
    runs: 0
  };
  const [isNewChat, setIsNewChat] = useState(false);
  const handleNewChat = (hstry: any[], onButtonClick = false) => {
    if (!!hstry) {
      setChatHistory([newChatPlayground, ...hstry]);
      setSelectedPrompt('');
      setIsNewChat(true);
      onButtonClick && resetingChat();
    }
    // }
  };

  useEffect(() => {
    const chatHistory_ = playgroundData?.data?.items;

    if (playgroundData?.loading) {
      return;
    }

    if (!!chatHistory_) {
      if (!!flag && isNewChat) {
        handleNewChat(chatHistory_);
        // setFlag(false);
      } else {
        setChatHistory(chatHistory_);
      }
    }
  }, [playgroundData?.loading]);

  // fetching messages for each playgroundRun
  useEffect(() => {
    const selectedPlaygroundRun = chatHistory?.filter(
      (item) => item?.playground_id === selectedPrompt
    )?.[0];

    if (messageHistory?.data?.messages) {
      setAllMessages(messageHistory?.data?.messages);
    }

    // update all details according to the selected Playground
    if (selectedPlaygroundRun?.playground_id) {
      const temp = selectedPlaygroundRun?.params;

      setInputData({
        ...inputData,
        // model: temp?.model || ModelOptions?.[3]?.title,
        temperature: temp?.temperature,
        maximumLength: temp?.max_length,
        topP: temp?.top_p,
        frequencyPenalty: temp?.frequency_penalty || 0,
        presencePenalty: temp?.presence_penalty || 0,
        systemPrompt: selectedPlaygroundRun?.systemPrompt || selectedPlaygroundRun?.name,
        stopSequence: temp?.stop_sequences || [],
        variable: selectedPlaygroundRun?.variables || []
      });
    }
  }, [messageHistory]);

  // scrolling down to the last message
  useEffect(() => {
    handleScrollToBottom();
  }, [allMessages]);

  //////////////////////
  const resetData = {
    editStatus: '',
    newMessage: '',
    loading: false
  };
  const [editMessage, setEditMessage] = useState(resetData);

  useEffect(() => {
    if (editMessage?.editStatus) {
      if (!!editChatMessage?.data?.run_id) {
        // console.log(editChatMessage?.data?.cost_eur, 'fdsdfds', allMessages, editMessage?.editStatus);

        const cutIndex = allMessages?.findIndex((item) => item.run_id === editMessage?.editStatus);
        const result = cutIndex !== -1 ? allMessages?.slice(0, cutIndex) : allMessages;

        if (!editChatMessage?.loading) {
          const updatedMessages = [
            ...result,
            {
              run_id: editChatMessage?.data?.run_id,
              role: 'user',
              message: editMessage?.newMessage
            },
            {
              run_id: editChatMessage?.data?.run_id,
              role: 'assistant',
              message: editChatMessage?.data?.assistant
            }
          ];

          setAllMessages(updatedMessages);
          setEditMessage(resetData);

          // side navigation bar for Deductions
          setDeduction(editChatMessage?.data?.cost_eur);
          // creditDataFunction();
        }
      }
    }
  }, [editChatMessage]);

  const functionBox = (item: any, index: number) => {
    // console.log(item, 'vvvvitemitem');
    // ('user');
    // const isUser = item?.role !== 'assistant';
    // const isAI = item?.role === 'assistant';

    const isUser = item?.role?.toLowerCase() === 'user';
    const isAI = !isUser;

    const isEditMode = item?.run_id ? editMessage?.editStatus === item?.run_id : false;

    return (
      <div
        className={`functionBox chat-message d-flex ${
          isUser ? 'justify-content-end' : 'justify-content-start'
        }`}>
        {/* AI*/}
        {isAI && item?.message && (
          <>
            <div className="chat-icon me-2">
              {/* <div className="circle-icon">🤖</div> */}

              <div className="circle-icon">{item?.role?.slice(0, 2)?.toUpperCase()}</div>
            </div>
            <div className="chat-bubble ai-bubble">
              <span className="fw-bold"> {item?.role}:</span>
              <ReactMarkdown>{item?.message}</ReactMarkdown>
              <div className="hover-icons">
                {/* <Like className="mx-1" />
                <Dislike className="mx-1" /> */}
                <CopyIcon
                  className="mx-1"
                  onClick={() => navigator.clipboard.writeText(item?.message || 'not available')}
                />
              </div>
            </div>
          </>
        )}

        {/* User */}
        {isUser && item?.message && (
          <>
            <div
              className="chat-bubble user-bubble"
              style={isEditMode ? { width: '50%', height: '100px' } : {}}>
              {isEditMode ? (
                <>
                  <TextArea
                    disabled={editChatMessage?.loading}
                    placeholder="Edit Your Message"
                    action={(a: string) => {
                      setEditMessage({ ...editMessage, newMessage: a });
                    }}
                    value={editMessage?.newMessage}
                    areaStyle={{ height: '80px' }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        if (!editMessage?.newMessage) {
                          alert('Enter your Question');
                          return;
                        }
                        if (editMessage?.run_id) {
                          alert('Run ID not available');
                          return;
                        }
                        EditChatMessageFunction({
                          playground_id: selectedPrompt || '',
                          edit_run_id: editMessage?.editStatus,
                          new_user_message: editMessage?.newMessage,
                          credit_id: CREDIT_ID,
                          tuning: [tuningData],
                          system_prompt: inputData?.systemPrompt,
                          variables: inputData?.variable
                        });
                        setEditMessage({ ...editMessage, loading: true });
                      }
                    }}
                  />
                  <div
                    className="d-flex justify-content-end"
                    style={{ position: 'relative', zIndex: 2, top: 10 }}>
                    <PlainButton buttonAction={() => setEditMessage(resetData)}>Cancel</PlainButton>
                  </div>
                </>
              ) : (
                <div>
                  <ReactMarkdown>{item?.message}</ReactMarkdown>
                  {item?.run_id && !isEditMode && (
                    <div className="hover-icons" style={{ bottom: '-20px' }}>
                      <Edit_1
                        onClick={() => {
                          setEditMessage({
                            ...editMessage,
                            editStatus: item?.run_id,
                            newMessage: item?.message
                          });
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="chat-icon ms-2">
              <div className="circle-icon">👤</div>
            </div>
          </>
        )}
      </div>
    );
  };
  const containerRef = useRef<HTMLDivElement | null>(null);
  const handleScrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };
  const {
    data: ResponseData = {
      assembled_prompt: '',
      user_facing_message: { message: '' },
      run_timestamp: ''
    },
    loading: ResponseLoading = false
  } = chatData;

  // handling message sending
  const handleSend = () => {
    if (!inputData?.model || !CREDIT_ID) {
      return alert('Billing Application and Model Selection are Mandatory');
    }
    const myQuery = {
      role: 'user',
      message: myMessage,
      run_id: ''
    };

    const myTuning = [tuningData];
    setAllMessages([...allMessages, myQuery]);
    var payload = {
      session_id: selectedPrompt,
      credit_id: CREDIT_ID,
      system_prompt: inputData?.systemPrompt,
      conversation: {
        roles: [myQuery]
      },
      tuning: myTuning,
      variables: inputData?.variable
    };

    var payload_new = {
      new_session: true,
      credit_id: CREDIT_ID,
      system_prompt: inputData?.systemPrompt,
      conversation: {
        // here allMessages are included to give reference to old chats in the prompt
        roles: [...allMessages, myQuery]
      },
      variables: inputData?.variable,
      tuning: myTuning,
      flags: {
        ui_mode: 'playground'
      }
    };

    const selectedIndex = IndexOptions?.filter((item) => item?.id === indexSelection?.index)?.[0];
    const indexRelatedData = {
      index: selectedIndex?.title,
      ai_search_service_name: selectedIndex?.serviceName,
      search_top_k: indexSelection?.topK
    };

    if (selectedIndex?.title) {
      payload = { ...payload, ...indexRelatedData };
      payload_new = {
        ...payload_new,
        ...indexRelatedData,
        flags: { ...payload_new?.flags, rag_only: false }
      };
    }

    try {
      if (isNewChat) {
        // alert('New Chat');
        // console.log(payload_new, 'payloadPayload');
        ChatFunction(payload_new);
      } else {
        // alert('Chat Old');
        // console.log(payload, 'payloadPayload');
        ChatFunction(payload);
      }
    } catch (err) {
      console.log(err);
      alert(err);
    } finally {
      setMyMessage('');
    }
  };

  useEffect(() => {
    if (!ResponseData) {
      return;
    }
    const assistantMessage =
      ResponseData?.assembled_prompt || ResponseData?.user_facing_message?.message || '';

    // to add Run_id to the question adked , Run_id fetched from the Response
    if (allMessages?.length) {
      allMessages[allMessages.length - 1].run_id = ResponseData?.run_id;
    }

    const temp = [
      ...allMessages,
      {
        message: assistantMessage,
        role: 'assistant',
        timestamp: ResponseData?.run_timestamp ?? ''
      }
    ];

    // to avoid updating AllMessages , if assistantMessage is not available
    assistantMessage && setAllMessages(temp);

    if (isNewChat) {
      setIsNewChat(false);
      // for new chat fetching the Run_ID of the
      // ResponseData?.playground_id &&
      //   MessageHistoryFunction(ResponseData?.playground_id?.toUpperCase());
      setSelectedPrompt(ResponseData?.playground_id?.toUpperCase());
      playgroundDetails();
    }
    setDeduction(ResponseData?.cost_eur);
    // creditDataFunction();

    // resetChatFunction();
  }, [ResponseData]);

  //

  const [myMessage, setMyMessage] = useState('');
  const handleSelection = (fieldName: string, value: string) => {
    setInputData({ ...inputData, [fieldName]: value });
  };

  /////Variable Management
  const handleVariableUpdates = (name, value, index) => {
    if (name === 'VariableName' && value?.includes(' ')) {
      alert('space(" ") not allowed , instead use "_" ');
      return;
    }

    const tempVariables = [...inputData.variable];

    // Update only the field being changed
    tempVariables[index] = {
      ...tempVariables[index],
      [name]: value
    };

    setInputData({
      ...inputData,
      variable: tempVariables
    });
  };

  const variableFields = (item, index) => {
    const handleDeleteVariable = () => {
      const temp = [...inputData.variable];
      temp.splice(index, 1);
      setInputData({
        ...inputData,
        variable: temp
      });
    };

    return (
      <div
        style={{
          ...borderDetails,
          padding: 16,
          marginTop: 20,
          position: 'relative'
        }}
        key={index}>
        <BlackTrash
          style={{ position: 'absolute', top: 30, right: 20, cursor: 'pointer' }}
          onClick={handleDeleteVariable}
        />
        {[
          {
            header: 'Variable Name ',
            placeholder: 'Enter Variable Name',
            paramName: 'VariableName',
            toolTip:
              'Create reusable fields that can be inserted into the prompt using {{variableName}}. Add a name, optional default value, and a short description for each variable.'
          },
          {
            header: 'Default Value',
            placeholder: 'Enter Value',
            paramName: 'DefaultValue'
          },
          {
            header: 'Description',
            placeholder: 'Description',
            paramName: 'Description'
          }
        ].map((dt) => (
          <TextFieldComponent
            key={dt.paramName}
            header={dt.header}
            toolTip={dt?.toolTip || ''}
            isMandatory={false}
            placeholder={dt.placeholder}
            paramName={dt.paramName}
            value={item?.[dt.paramName] || ''}
            handleSelection={(paramName, val) => handleVariableUpdates(paramName, val, index)}
          />
        ))}
      </div>
    );
  };

  const handleAddVariable = (e) => {
    e.stopPropagation();

    const dummy = {
      VariableName: '',
      DefaultValue: '',
      Description: ''
    };

    const temp = [...inputData.variable];

    // Add new variable only if previous one is filled
    if (!temp.length || temp[0].VariableName) {
      setInputData({
        ...inputData,
        variable: [dummy, ...temp]
      });
    } else {
      alert('Please fill the already added variables first');
    }
  };

  const resetingChat = () => {
    // alert('resetiing Chat');
    setSelectedPrompt('');
    setAllMessages([]);
    setInputData(promptParams);
    setDataToShow({});
    setMyPrompt('');
    setMyPromptLocal('');
    //
    setIsNewChat(true);
    // for resetting indexData
    handleSetIndexData('topK', '');
    handleSetIndexData('index', '');
  };

  //
  const [isSavePrompt, setSavePromptPopUp] = useState(false);

  const handleStopSequence = (val) => {
    const temp = val?.split(' ');
    setInputData({ ...inputData, stopSequence: temp });
  };

  const [searchText, setSearchText] = useState('');
  const handleSearch = () => {
    if (!searchText) {
      return chatHistory;
    }
    return chatHistory?.filter((item) => item?.preview?.toLowerCase()?.includes(searchText));
  };

  return (
    <div
      style={{
        padding: 20,
        paddingBottom: 5,
        height: 'calc(100vh - 100px)',
        overflow: 'auto'
      }}>
      <ModelView
        header={'Prompt Samples'}
        open={!!popUpType}
        handleClose={() => {
          setPopUpType('');
        }}></ModelView>

      <SavePromptPopUp
        open={isSavePrompt}
        handleClose={() => setSavePromptPopUp(false)}
        isNew={myPrompt}
        header="Save Prompt"
        description={myPrompt ? 'Save Your New Prompt' : 'Select where to save the prompt'}
        inputData={inputData}
        allMessages={allMessages || []}
        dataToShow={dataToShow}
        selectedVersion={selectedVersion}
      />
      {/* Header of the Page */}

      <div className="d-flex justify-content-between" style={{ height: '10%' }}>
        <div
          style={{ maxWidth: '40%', position: 'relative', display: 'flex', alignItems: 'center' }}>
          <PageHeader
            headerName="Prompt Playground"
            description="Play around with prompts, test responses, and see what the AI can do — live and interactive.">
            <img
              style={{ width: '24px', height: '24px', marginRight: '5px', fontWeight: '600px' }}
              src={require('../assets/img/promptLibrary.png')}
            />
          </PageHeader>
          <div
            style={{
              position: 'absolute'
            }}>
            {myPromptLocal && (
              <div style={{ position: 'relative', left: '220px', bottom: '27px' }}>
                <BlueDropDownComponent
                  versionsData={availableVersions}
                  handleSelection={(a, b) => setSelectedVersion(b)}
                  selectedVersion={selectedVersion}
                />
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
          <PlainButton buttonAction={() => setIsViewMaximum(!isViewMaximum)}>
            <Folder style={iconStyle} />
            {isViewMaximum ? 'Minimize' : 'Maximize'} UI
          </PlainButton>
          <PlainButton
            buttonAction={() => {
              navigate(`/comparePrompts`);
            }}>
            <Folder style={iconStyle} />
            Compare Prompts
          </PlainButton>
          <PlainButton
            styleClass={{ margin: '0 10px' }}
            buttonAction={() => setPopUpType('compare')}>
            <DoubleSideArrow style={iconStyle} />
            Choose From prompt lib
          </PlainButton>

          <UnileverButton
            buttonAction={() => {
              setSavePromptPopUp(true);
            }}>
            <Save style={iconStyle} />
            Save Prompt
          </UnileverButton>
        </div>
      </div>
      <div className="d-flex justify-content-between" style={{ height: '90%' }}>
        {/* Left Box */}
        <div
          className={isViewMaximum ? 'd-none' : 'd-inline'}
          style={{ width: '20%', maxWidth: '350px' }}>
          <div className="chat_history_container">
            <div className="playground-container">
              <div className="header mt-2 ps-2">
                <h5 className="m-0">Playground History</h5>

                {!!chatHistory?.[0]?.playground_id && (
                  <PlainButton
                    buttonAction={() => handleNewChat(playgroundData?.data?.items, true)}>
                    {' '}
                    + New
                  </PlainButton>
                )}
              </div>
              <TextFieldComponent
                placeholder="Search from History Chat"
                handleSelection={(a: string, b: string) => {
                  setSearchText(b?.toLowerCase());
                }}
                value={searchText}
              />
              {playgroundData?.loading ? (
                // <p>Loading Chat History...</p>
                <UnileverAnimation />
              ) : (
                <ListGroup variant="flush" className="history-list">
                  {handleSearch()?.map((item, index) => (
                    <ToolTipFunction toolTipText={<>{item?.name}</>} placement="bottom">
                      <ListGroup.Item
                        action
                        className={
                          selectedPrompt === item?.playground_id
                            ? 'active-item listItemHover'
                            : '' + 'listItemHover'
                        }
                        onClick={() => {
                          if (item?.playground_id) {
                            setSelectedPrompt(item?.playground_id);
                            MessageHistoryFunction(item?.playground_id);
                            setMyMessage('');
                            !!isNewChat && setIsNewChat(false);
                          } else {
                            resetingChat();
                          }
                        }}
                        style={{ maxWidth: '95%', padding: 10 }}>
                        <div className="d-flex position-relative">
                          <span> {item?.preview}</span>{' '}
                          {item?.playground_id && (
                            <DeletePopUpIcon
                              style={{ width: '25px', height: '25px' }}
                              className="position-absolute trashIcon"
                              onClick={(e) => {
                                e.stopPropagation();
                                PlaygroundChatDeleteFunction(item?.playground_id);
                                const temp = chatHistory?.filter(
                                  (hstry) => hstry?.playground_id !== item?.playground_id
                                );
                                setChatHistory(temp);
                                resetingChat();
                              }}
                            />
                          )}
                        </div>
                      </ListGroup.Item>
                    </ToolTipFunction>
                  ))}
                </ListGroup>
              )}
            </div>
          </div>
        </div>
        {/* Center Box */}{' '}
        <div
          style={{
            width: '100%',
            margin: '0 10px',
            height: '100%'
          }}>
          <div className="mb-2">
            <Accordion
              title={'System Prompt'}
              isMandatory={false}
              defaultOpen={false}
              rightButton={
                inputData?.systemPrompt && (
                  <div style={{ cursor: 'pointer' }}>
                    <CopyIcon
                      className="me-2"
                      onClick={() => navigator.clipboard.writeText(inputData?.systemPrompt)}
                    />
                    <BlackTrash
                      className="me-2"
                      onClick={() => {
                        handleSelection('systemPrompt', '');
                      }}
                    />
                    {/* <Sparkle className="me-2" /> */}
                  </div>
                )
              }>
              <TextArea
                placeholder={
                  'Give the model context to understand the task and provide tailored responses.'
                }
                numberOfLines={4}
                areaStyle={{ height: '75px', border: 'none' }}
                action={(value: string) => handleSelection('systemPrompt', value)}
                value={inputData?.systemPrompt}></TextArea>
            </Accordion>
          </div>

          <div
            style={{
              ...borderDetails,

              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '93%'
            }}>
            <div
              style={{
                borderBottom: '1px solid var(--border-color-grey)',
                height: 51
              }}
              className="d-flex align-items-center justify-content-between">
              <div className="ps-2 chat_heading">Conversation</div>
              <div></div>
            </div>
            <div ref={containerRef} style={{ height: '100%', overflowY: 'auto', padding: '10px' }}>
              {messageHistory?.loading ? (
                // <Spinner />
                <div className="h-100 d-flex justify-content-center align-items-center">
                  <UnileverAnimation />
                </div>
              ) : (
                allMessages?.map((item, index) => functionBox(item, index))
              )}
            </div>

            {/* TextBox Area */}
            {ResponseLoading || editChatMessage?.loading ? (
              <div className="d-flex  justify-content-center">
                <UnileverAnimation />
              </div>
            ) : (
              <div style={{ position: 'relative', padding: 10 }}>
                <TextArea
                  disabled={editChatMessage?.loading}
                  numberOfLines={4}
                  placeholder="Write Your prompt here"
                  areaStyle={{ height: '104px', backgroundColor: 'rgba(248, 248, 248, 1)' }}
                  value={myMessage}
                  action={(value) => setMyMessage(value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault(); // stops new line
                      if (myMessage.trim()) {
                        handleSend();
                      }
                    }
                  }}
                />
                <div style={{ position: 'absolute', top: 70, right: 20, display: 'flex' }}>
                  {/* <Attachment /> */}
                  {myMessage ? <SendButton onClick={handleSend} /> : <></>}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Right  Box */}
        <div
          className={isViewMaximum ? 'd-none' : 'd-inline' + 'chat_history_container'}
          style={{
            width: '20%',
            maxWidth: '350px',
            height: '100%',
            overflow: 'auto',
            scrollbarWidth: 'none'
          }}>
          <CreditBalanceBox />
          <Accordion title="Tuning" defaultOpen={false}>
            <div>
              <SearchableDropDownComponent
                fieldName="Model"
                isMandatory={false}
                options={ModelOptions}
                paramName={'model'}
                value={inputData?.model}
                handleSelection={(a, b) => handleSelection(a, b)}
              />

              <div className="my-3">
                {[
                  {
                    fieldName: 'Temperature',
                    paranName: 'temperature',
                    min: 0,
                    max: 2,
                    steps: 2 / 10,
                    toolTipMessage:
                      'Controls randomness. Higher temperature generates more creative responses; lower temperature makes output more focused and deterministic.',
                    value: inputData?.temperature
                  },
                  {
                    fieldName: 'Maximum Length',
                    paranName: 'maximumLength',
                    min: 1,
                    max: 4000,
                    steps: 4000 / 100,
                    toolTipMessage:
                      'Defines the maximum number of tokens the model can generate in the response.',
                    value: inputData?.maximumLength
                  }
                ]?.map((item) => (
                  <div>
                    <RangeSelector
                      name={item?.fieldName}
                      toolTip={item?.toolTipMessage}
                      paramName={item?.paranName}
                      handleSelection={(a, b) => handleSelection(a, b)}
                      min={item?.min}
                      max={item?.max}
                      steps={item?.steps}
                      value={item?.value}
                    />
                  </div>
                ))}
              </div>
              <div className="my-3 relative">
                <TextArea
                  header="Stop Sequence"
                  toolTip="Specify one or more sequences where the model will stop generating further output."
                  description="Enter sequence and press tab"
                  numberOfLines={1}
                  areaStyle={{ height: '50px', padding: 12 }}
                  value={inputData?.stopSequence?.join(' ')}
                  action={(value) => {
                    handleStopSequence(value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                      e.preventDefault();
                      handleStopSequence(e.target.value + ' ');
                    }
                  }}
                />
              </div>

              <div className="my-3">
                {[
                  {
                    fieldName: 'Top P',
                    paranName: 'topP',
                    min: 0,
                    max: 1,
                    step: 1 / 10,
                    value: inputData?.topP,
                    toolTipMessage:
                      'Controls diversity using nucleus sampling. The model considers only the most probable tokens whose cumulative probability reaches the Top-P value.'
                  },
                  {
                    fieldName: 'Frequency Penalty',
                    paranName: 'frequencyPenalty',
                    min: -2,
                    max: 2,
                    step: 2 / 10,
                    value: inputData?.frequencyPenalty,
                    toolTipMessage:
                      'Reduces the likelihood of the model repeating the same words. Higher values discourage repetition.'
                  },
                  {
                    fieldName: 'Presence Penalty',
                    paranName: 'presencePenalty',
                    min: -2,
                    max: 2,
                    step: 2 / 10,
                    value: inputData?.presencePenalty,
                    toolTipMessage:
                      'Encourages the model to talk about new topics. Higher values increase the chance of introducing fresh ideas.'
                  }
                ]?.map((item) => (
                  <div>
                    <RangeSelector
                      name={item?.fieldName}
                      toolTip={item.toolTipMessage}
                      paramName={item?.paranName}
                      handleSelection={(a, b) => handleSelection(a, b)}
                      min={item?.min}
                      max={item?.max}
                      steps={item?.steps}
                      value={item?.value}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Accordion>
          <Accordion
            title="Variables"
            defaultOpen={false}
            rightButton={
              <PlainButton buttonAction={handleAddVariable}>+ Add Variables</PlainButton>
            }>
            <div className="mt-2">
              {inputData?.variable?.map((item, index) => variableFields(item, index))}
            </div>
          </Accordion>
        </div>
      </div>
    </div>
  );
}
